module.exports = __webpack_public_path__ + "static/media/NavLogo.6404fc4f.png";